import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useIdentificationHelpers } from "@Client/@Composables/application-standalone/pages/identifications/useIdentificationHelpers";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import { computed, defineComponent, onMounted, ref, watch } from "@vue/composition-api";
import PageSummarySectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-summary-section-group-layout.vue";
import { useSummaryHelpers } from "@Client/@Composables/application-standalone/pages/summary/useSummaryHelpers";
import { useValidatorsHelper } from "@Client/@Composables/application-standalone/validations/useValidatorsHelper";
import ApplicationSectionErrorIcon from "@Client/@Modules/application-standalone/components/helpers/application-section-error-icon.vue";
import { ordinalIndex } from "@Shared/@Utils/helpers/text";
import RemoveComponentModal from "./../remove-component-modal.vue";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "IdentificationSummary",
  components: {
    PageSummarySectionGroupLayout,
    SectionTitle,
    ApplicationSectionErrorIcon,
    RemoveComponentModal
  },
  props: {
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    const invalidIdentifications = ref([]);
    const {
      t
    } = useI18n();
    const {
      allApplicants,
      applicantNameFromIndex,
      isApplicantVisibleFromFillOut
    } = useApplicantHelpers();
    const {
      getTextForAddButton,
      editButtonText,
      allowEdit
    } = useSummaryHelpers();
    const {
      getInvalidIdentifications
    } = useValidatorsHelper();
    onMounted(() => {
      updateInvalidIdentifications();
    });
    const updateInvalidIdentifications = async () => {
      invalidIdentifications.value = await getInvalidIdentifications();
    };
    const areInvalidIdentifications = computed(() => !!invalidIdentifications.value.length);
    watch(areInvalidIdentifications, newValue => emit("disable-save", newValue), {
      immediate: true
    });
    const {
      identificationSummarySubtitle,
      applicantHasIdentification,
      addEmptyIdentification,
      deleteIdentification,
      isIdentificationSectionVisibleForMainApplicant,
      isIdentificationSectionVisibleForCoApplicants
    } = useIdentificationHelpers();
    const handleAddIdentification = (applicantIndex, applicantId) => {
      addEmptyIdentification(applicantIndex);
      const applicant = allApplicants.value[applicantIndex];
      if (applicant) {
        handleNavigation(applicantIndex, applicant.identifications.length - 1, applicantId);
      }
    };
    const handleNavigation = (applicantIndex, identificationIndex, applicantId = "") => {
      emit("navigate", {
        applicantIndex,
        identificationIndex,
        applicantId
      });
    };
    const addIdentificationButtonText = applicant => {
      return getTextForAddButton("application-standalone.pages.identifications.addIdentification", {
        iteratee: applicantHasIdentification,
        singleValue: applicant["identifications"]
      });
    };
    const isSectionVisibleToApplicant = (applicantIndex, applicantId) => {
      const visibleFromSchema = applicantIndex === 0 ? isIdentificationSectionVisibleForMainApplicant.value : isIdentificationSectionVisibleForCoApplicants.value;
      const visibleFromFillOut = isApplicantVisibleFromFillOut(applicantId);
      return visibleFromSchema && visibleFromFillOut;
    };
    const isInvalid = (applicantIdx, index) => {
      return invalidIdentifications.value.some(({
        identificationIndex,
        applicantIndex
      }) => identificationIndex === index && applicantIndex === applicantIdx);
    };
    const firstErrorId = computed(() => {
      var _invalidIdentificatio, _invalidIdentificatio2, _invalidIdentificatio3;
      return (_invalidIdentificatio = (_invalidIdentificatio2 = invalidIdentifications.value) == null ? void 0 : (_invalidIdentificatio3 = _invalidIdentificatio2[0]) == null ? void 0 : _invalidIdentificatio3.identificationIndex) != null ? _invalidIdentificatio : null;
    });
    const handleDelete = ({
      applicantIndex,
      identificationIndex
    }) => {
      deleteIdentification(applicantIndex, identificationIndex);
      updateInvalidIdentifications();
    };
    const modalText = computed(() => {
      return t("application-form.removeComponentModalMessage", {
        componentType: "identification"
      });
    });
    const removeComponentModal = ref();
    const openDeletionModal = data => {
      var _removeComponentModal;
      removeComponentModal == null ? void 0 : (_removeComponentModal = removeComponentModal.value) == null ? void 0 : _removeComponentModal.openModal(data);
    };
    return {
      handleAddIdentification,
      allApplicants,
      applicantNameFromIndex,
      handleNavigation,
      deleteIdentification,
      identificationSummarySubtitle,
      applicantHasIdentification,
      addIdentificationButtonText,
      isSectionVisibleToApplicant,
      isInvalid,
      updateInvalidIdentifications,
      invalidIdentifications,
      editButtonText,
      allowEdit,
      firstErrorId,
      handleDelete,
      ordinalIndex,
      areInvalidIdentifications,
      modalText,
      removeComponentModal,
      openDeletionModal
    };
  }
});